import { Component, inject } from "@angular/core";
import { PageHeaderComponent } from "../../../shared/components/page-header/page-header.component";
import { CommonModule } from "@angular/common";
import { AppLayoutComponent } from "../../../shared/components/app-layout/app-layout.component";
import { FollowedProducersEventsComponent } from "./followed-producers-events/followed-producers-events.component";
import { FollowedProducersComponent } from "./followed-producers/followed-producers.component";
import { EventsManagementService } from "../../services/events-management.service";
import { RelationshipsService } from "../../services/relationships.service";
import { map } from "rxjs";

@Component({
    selector: "app-followed-producers-page",
    imports: [
        CommonModule,
        AppLayoutComponent,
        PageHeaderComponent,
        FollowedProducersEventsComponent,
        FollowedProducersComponent,
    ],
    templateUrl: "./followed-producers-page.component.html",
    styleUrl: "./followed-producers-page.component.scss"
})
export class FollowedProducersPageComponent {
  private readonly eventsService = inject(EventsManagementService);
  private readonly relationshipsService = inject(RelationshipsService);

  followedProducersEvents$ = this.eventsService
    .getFollowedProducersEvents()
    .pipe(map((response) => response.flatMap((producer) => producer.events)));

  followedProducers$ = this.relationshipsService
    .getFollowing(1, 50)
    .pipe(map((page) => page.data));
}
